export enum PhoneTypeEnum {
  CELLULAR= 'CELLULAR',
  LOCAL = 'LOCAL',
  FAX = 'FAX',
}
